import React from 'react';
import './CookiesConsent.scss';
import { useLocation } from 'react-router-dom';
import { Link } from '../../Devon/Components/InkyLink';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { useAtomValue } from 'jotai';

const CookiesConsent = ({ setCookiesConsentValue }): JSX.Element => {
    const location = useLocation();
    const isNewsPage = location.pathname === '/news'
    const isBrowsePage = location.pathname === '/browse'

    return (
        <div className={`cookies-consent-container ${isBrowsePage ? "cookies-consent-container-browse" : ""} ${isNewsPage ? "cookies-consent-container-news" : ""}`}>
            <span className='cookies-consent-text'>
                By default, we use tracking cookies to help improve your experience on this site. Please confirm your preferences.
            </span>
            <span className='cookies-consent-info'>
                More information is available in our <Link to={'/privacy-policy'}
                                                           target={"_blank"}
                                                           className='cookies-consent-info-link'>Privacy Policy.</Link>
            </span>
            <div className='cookies-consent-actions-wrapper'>
                <KodanshaArrow onClick={() => setCookiesConsentValue(true)} text={'Allow All Cookies'} withArrow={false}
                               styles={'allow-cookies'} />
                <KodanshaArrow onClick={() => setCookiesConsentValue(true)} text={'Required Only'} withArrow={false}
                               styles={'required-cookies'} />
            </div>
        </div>
    );
};

export default CookiesConsent;